<template>
  <div>
    <van-button
      type="info"
      @click="viewDetails(2)"
      v-if="refundData.refundModel.STATE != null"
      >查看退款</van-button
    >
    <van-button type="danger" @click="viewDetails(1)" v-else>申请退款</van-button>
    <van-button type="primary" @click="viewDetails(3)">首页待办跳转</van-button>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      orderCode: "LC2205240200",
      //  'LC2205240200'     纸质
      //  'LC2205300200'     纸质
      //  'LC2206060203'     纸质
      //  'LC2206070200'     纸质
      //  'LC2207070202'     电子
      //  'QD2205110201'     纸质
      //  'QD2205110202'     纸质
      refundData: {
        refundModel: {
          STATE: null, // 2:提交 1:保存
          FOUR_AUDIT_STATUS: "",
        },
      },
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    viewDetails(type) {
      if (type == 1) {
        this.$router.push({
          path: "/order/refundDetails",
          query:{
            orderCode:this.orderCode
          }
        });
      } else if (type == 2) {
        //详情跳转进入
        this.$router.push({
          path: "/order/refundApproval",
          query:{
            orderCode: this.orderCode,
            parameterId: "1-1",
          }
        });
      } else {
        //首页待办跳转进入，加一个参数
        let id = 2653; //取当前数据的这个字段 ‘PARAMETER_ID’
        this.$router.push({
          path: "/order/refundApproval",
          query:{
            orderCode: this.orderCode,
            parameterId:id
          }
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped></style>
